import styled from '@emotion/styled';
import { H5 } from 'toolkit/components';
import { removeCentsAddCommas } from '../value/utilities';
import { Cell } from './types';

interface RegularCellProps {
  data: Cell;
  trafficValAvg: number;
}

const ToolTipText = styled(H5)`
  color: ${(props) => props.color};
`;

const RegularCell = ({ data, trafficValAvg }: RegularCellProps) => {
  const { value } = data.cell;
  const pubComparisonColor = value >= trafficValAvg ? 'green' : 'red';

  return (
    <ToolTipText color={pubComparisonColor}>${removeCentsAddCommas(value as number)}</ToolTipText>
  );
};

export default RegularCell;
